import { render, staticRenderFns } from "./IconConnection.vue?vue&type=template&id=0002bb5d"
import script from "./IconConnection.vue?vue&type=script&lang=js"
export * from "./IconConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports